/* eslint-disable no-nested-ternary */
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import activate from '../../../../../assets/images/icons/activate.svg';
import check from '../../../../../assets/images/icons/check.svg';
import exclamation from '../../../../../assets/images/icons/exclamation.svg';
import exclamationYellow from '../../../../../assets/images/icons/exclamationYellow.svg';
import eye from '../../../../../assets/images/icons/eye.svg';
import maps from '../../../../../assets/images/icons/maps.svg';
import suspend from '../../../../../assets/images/icons/suspend.svg';
import {
  Card,
} from '../../../../../components/Lists';
import OpacityAnimation from '../../../../../components/OpacityAnimation';
import useGetGeneralAppData from '../../../../../hooks/useGetGeneralAppData';
import formatCurrency from '../../../../../utils/formatCurrency';
import { MappedPassengerType } from '../../types';

interface ListInterface {
  filteredPassengers: MappedPassengerType[];
  handleOpenPassengerRoutingModal: (passengerInfo: MappedPassengerType) => void;
  handleOpenPassengerInfoModal: (passengerInfo: MappedPassengerType) => void;
  handleOpenInactivateModal: (passengerName: string, employeeCode: number) => void;
  handleOpenReactivateModal: (passengerName: string, employeeCode: number) => void;
}

export default function List({
  filteredPassengers,
  handleOpenPassengerRoutingModal,
  handleOpenInactivateModal,
  handleOpenReactivateModal,
  handleOpenPassengerInfoModal,
}: ListInterface) {
  const { permissions } = useGetGeneralAppData();
  const affreightmentsPassengersPermissions = permissions.find((x) => x.codPag === 12);

  return (
    <Container>
      <Row xs={1} md={1} lg={2}>
        {filteredPassengers?.map((psg) => (
          <Col key={psg.employeeCode}>
            <OpacityAnimation delay={0.1}>
              <Card>
                <div className="info">
                  <div className="card-title">
                    <strong>{psg.name}</strong>
                    {psg.status === 'Ativo'
                      ? <small className="green">Ativo</small>
                      : (
                        <small className="orange">
                          {psg.inactiveDate
                            ? `Inativo até ${new Date(psg.inactiveDate.replace(/-/g, '\/')).toLocaleDateString()}`
                            : 'Inativo'}
                        </small>
                      )}
                  </div>
                  <span>
                    {psg.vtValue === 0
                      ? <>Não usa VT</>
                      : formatCurrency(String(psg.vtValue))}
                  </span>
                  <span>
                    <div>
                      <strong>Ida:</strong>
                      {' '}
                      {psg.goingLine.replace('.kml', '').toLowerCase()}
                    </div>
                    {psg.goingLineStatus === 'Titular'
                      ? <img src={check} alt="titular" title="Titular na linha" />
                      : (
                        psg.goingLineStatus === 'Avulso'
                          ? <img src={exclamationYellow} alt="Avulso na linha" title="Avulso na linha" />
                          : <img src={exclamation} alt="perdeu titularidade" title="Perdeu titularidade na linha" />
                      )}
                  </span>
                  <span>
                    <div>
                      <strong>Volta:</strong>
                      {' '}
                      {psg.backLine.replace('.kml', '').toLowerCase()}
                    </div>
                    {psg.backLineStatus === 'Titular'
                      ? <img src={check} alt="titular" title="Titular na linha" />
                      : (
                        psg.backLineStatus === 'Avulso'
                          ? <img src={exclamationYellow} alt="Avulso na linha" title="Avulso na linha" />
                          : <img src={exclamation} alt="perdeu titularidade" title="Perdeu titularidade na linha" />
                      )}
                  </span>
                </div>

                <div className="actions">
                  <button type='button' onClick={() => handleOpenPassengerInfoModal(psg)}>
                    <img src={eye} alt="maps" title="Ver detalhes do passageiro" />
                  </button>

                  <button type='button' onClick={() => handleOpenPassengerRoutingModal(psg)}>
                    <img src={maps} alt="maps" title="Ver roteirização do passageiro" />
                  </button>

                  {psg.status !== 'Ativo' && (affreightmentsPassengersPermissions?.incluir || affreightmentsPassengersPermissions?.alterar) && (
                    <button type='button' onClick={() => handleOpenReactivateModal(psg.name, psg.employeeCode)}>
                      <img src={activate} alt="edit" title="Reativar passageiro" />
                    </button>
                  )}


                  {psg.status === 'Ativo' && (affreightmentsPassengersPermissions?.excluir || affreightmentsPassengersPermissions?.alterar) && (
                    <button type='button' onClick={() => handleOpenInactivateModal(psg.name, psg.employeeCode)}>
                      <img src={suspend} alt="trash" title="Inativar passageiro" />
                    </button>
                  )}
                </div>

              </Card>
            </OpacityAnimation>
          </Col>
        ))}
      </Row>
    </Container>
  );
}
